module.exports = __webpack_public_path__ + "img/ia-logo.7d99eff6.png";